export const StreetMinLength = 2;
export const StreetMaxLength = 150;
export const StreetDebounceTime = 300;
export const RequestLimit = 10;
export const StreetControlName = 'street';
export const StreetLabel = 'Вулиця';
export const StreetPlaceholder = '';
export const StreetClasses = 'form-col w-50';
